import { publicProfileConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import { showWarningMessage } from "../../../_uiComponents/ShowMessageSnack";

//schedule interview
export const get_user_public_profile_data_action = (id) => async (dispatch) => {
  dispatch({
    type: publicProfileConstants.GET_USER_PUBLIC_PROFILE_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      `${config.common.userPublicProfile.replace(":id", id)}`
    );
    if (response.status) {
      dispatch({
        type: publicProfileConstants.GET_USER_PUBLIC_PROFILE_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: publicProfileConstants.GET_USER_PUBLIC_PROFILE_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

//schedule interview
export const get_all_public_event_links_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: publicProfileConstants.GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.getAllPublicEventLinks.replace(":id", id)}`
      );
      if (response.status) {
        dispatch({
          type: publicProfileConstants.GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: publicProfileConstants.GET_ALL_PUBLIC_EVENT_LINKS_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const get_all_candidate_public_assessment_kits_lists_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.candidatePublicAssessmentKits.replace(":id", id)}`
      );
      if (response.status) {
        dispatch({
          type: publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_LISTS_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const get_all_candidate_public_assessment_kits_videos_data_action =
  (id, candidateId, page) => async (dispatch) => {
    dispatch({
      type: publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.candidatePublicAssessmentKitVideos.replace(
          ":id",
          id
        )}${candidateId}/?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: publicProfileConstants.GET_ALL_CANDIDATE_PUBLIC_ASSESSMENT_KITS_VIDEOS_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//schedule interview
export const get_mentor_public_profile_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.common.viewMentorPublicProfile.replace(":id", id)}`
      );
      if (response.status) {
        dispatch({
          type: publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

export const invite_new_candidate_to_apply = (data) => async (dispatch) => {
  // dispatch({
  //   type: publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_REQUEST,
  // });
  try {
    const response = await axiosInstance.post(
      `${config.common.inviteCandidateToApply}`,
      data
    );
    if (response.status) {
      // dispatch({
      //   type: publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_SUCCESS,
      //   payload: response.data,
      // });
      // showSuccessMessage("Candidate has been invited successfully")
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    // dispatch({
    //   type: publicProfileConstants.GET_MENTOR_PUBLIC_PROFILE_DATA_ACTION_FAILURE,
    //   payload: e.msg,
    // });
    showWarningMessage(e?.msg)
  }
};
